/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingResponseDtoValue } from './SystemSettingResponseDtoValue';
import {
    SystemSettingResponseDtoValueFromJSON,
    SystemSettingResponseDtoValueFromJSONTyped,
    SystemSettingResponseDtoValueToJSON,
    SystemSettingResponseDtoValueToJSONTyped,
} from './SystemSettingResponseDtoValue';

/**
 * 
 * @export
 * @interface UpdateSystemSettingRequestDto
 */
export interface UpdateSystemSettingRequestDto {
    /**
     * 
     * @type {SystemSettingResponseDtoValue}
     * @memberof UpdateSystemSettingRequestDto
     */
    value: SystemSettingResponseDtoValue;
    /**
     * 
     * @type {number}
     * @memberof UpdateSystemSettingRequestDto
     */
    expectedVersion: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSystemSettingRequestDto
     */
    reason?: string;
}

/**
 * Check if a given object implements the UpdateSystemSettingRequestDto interface.
 */
export function instanceOfUpdateSystemSettingRequestDto(value: object): value is UpdateSystemSettingRequestDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('expectedVersion' in value) || value['expectedVersion'] === undefined) return false;
    return true;
}

export function UpdateSystemSettingRequestDtoFromJSON(json: any): UpdateSystemSettingRequestDto {
    return UpdateSystemSettingRequestDtoFromJSONTyped(json, false);
}

export function UpdateSystemSettingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSystemSettingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': SystemSettingResponseDtoValueFromJSON(json['value']),
        'expectedVersion': json['expectedVersion'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function UpdateSystemSettingRequestDtoToJSON(json: any): UpdateSystemSettingRequestDto {
    return UpdateSystemSettingRequestDtoToJSONTyped(json, false);
}

export function UpdateSystemSettingRequestDtoToJSONTyped(value?: UpdateSystemSettingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': SystemSettingResponseDtoValueToJSON(value['value']),
        'expectedVersion': value['expectedVersion'],
        'reason': value['reason'],
    };
}

